import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import TopBar from "../../components/topBar/topBar";

function Terms() {
  const { t } = useTranslation();
  const location = useLocation();
  const [terms, setTerms] = useState("");
  const [privacy, setPrivacy] = useState("");

  useEffect(() => {
    fetch("/TERMS.md").then((r) => r.text()).then(setTerms);
    fetch("/PRIVACY.md").then((r) => r.text()).then(setPrivacy);
  }, []);

  useEffect(() => {
    if (!location.hash) return;
    const timer = setTimeout(() => {
      const el = document.getElementById(location.hash.slice(1));
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 100);
    return () => clearTimeout(timer);
  }, [location.hash, terms, privacy]);

  const mdComponents = {
    h1: ({ children }) => (
      <h1 className="mt-10 mb-4 text-2xl font-semibold text-mainDark">{children}</h1>
    ),
    h2: ({ children }) => (
      <h2 className="mt-8 mb-3 text-xl font-semibold text-mainDark">{children}</h2>
    ),
    p: ({ children }) => (
      <p className="mb-4 text-sm leading-relaxed text-mainDark/80 font-light">{children}</p>
    ),
    strong: ({ children }) => (
      <strong className="font-semibold text-mainDark">{children}</strong>
    ),
    ul: ({ children }) => (
      <ul className="mb-4 ml-6 list-disc space-y-1 text-sm text-mainDark/80 font-light">{children}</ul>
    ),
    ol: ({ children }) => (
      <ol className="mb-4 ml-6 list-decimal space-y-1 text-sm text-mainDark/80 font-light">{children}</ol>
    ),
    li: ({ children }) => <li className="leading-relaxed">{children}</li>,
    a: ({ href, children }) => (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="text-mainBlue underline underline-offset-2 transition-colors hover:text-mainDark"
      >
        {children}
      </a>
    ),
  };

  return (
    <div className="min-h-screen bg-mainWhite">
      <TopBar />

      <div className="mx-auto max-w-2xl px-6 py-12">
        <Link
          to="/"
          className="group mb-8 -ml-1 inline-flex items-center gap-2 text-sm font-light text-mainDark/40 transition-colors duration-200 hover:text-mainDark"
        >
          <svg className="h-4 w-4 transition-transform duration-200 group-hover:-translate-x-1" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M19 12H5M12 5l-7 7 7 7" />
          </svg>
          {t("login.backHome")}
        </Link>

        {/* Terms of Service */}
        <article className="prose-eulchen">
          <ReactMarkdown components={mdComponents}>{terms}</ReactMarkdown>
        </article>

        {/* Divider */}
        <div className="my-12 h-px bg-mainDark/10" />

        {/* Privacy Policy */}
        <article id="privacy" className="scroll-mt-24 prose-eulchen">
          <ReactMarkdown components={mdComponents}>{privacy}</ReactMarkdown>
        </article>

        <div className="mt-12 mb-8 text-center">
          <Link
            to="/"
            className="text-sm font-light text-mainBlue underline underline-offset-2 transition-colors hover:text-mainDark"
          >
            {t("login.backHome")}
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Terms;
